/** Field limits; the API enforces the same values in PresentationLayoutConstants. */
export const MAX_NAME_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 500;
export const MAX_LABEL_LENGTH = 255;

/** Operands a calculated column may use; equals the columns a section may have (PresentationLayoutConstants on the API). */
export const MAX_OPERANDS_PER_COLUMN = 30;

export const MESSAGE_META_LOAD_FAILED =
  "Could not load the KPIs, templates and deductibles for layouts. Create and Edit are unavailable until the page is reloaded.";
export const MESSAGE_ROW_TOTALS_NOT_NUMERIC =
  "Row totals need every KPI column to be a number, currency, percentage or Yes/No.";
/** Keep in sync with PresentationLayoutConstants::MESSAGE_BINDINGS_INCOMPLETE (ntcog-api). */
export const MESSAGE_BINDINGS_INCOMPLETE =
  "Some values are unavailable because a report template is not assigned to this entity.";

/** Keep in sync with PresentationLayoutConstants label-required errors (ntcog-api). */
export const MESSAGE_LABEL_REQUIRED = "Label is required.";
export const LABEL_USING_PREFIX = "Using:";

export const PLACEHOLDER_ROW_LABEL_KPI = "Defaults to the KPI name";
export const PLACEHOLDER_ROW_LABEL_ACTIVITY = "Defaults to the activity name";
export const PLACEHOLDER_ROW_LABEL_REQUIRED = "Row label";
export const PLACEHOLDER_COLUMN_LABEL_KPI = "Defaults to the KPI name";
export const PLACEHOLDER_COLUMN_LABEL_DEDUCTIBLE = "Defaults to the deductible name";
export const PLACEHOLDER_COLUMN_LABEL_REQUIRED = "Column label";

export const MESSAGE_LABEL_TOO_LONG = `Label must be at most ${MAX_LABEL_LENGTH} characters.`;

/** Test id prefixes; the builder and the preview can be on screen together, so they must differ. */
export const LAYOUT_BUILDER_SECTION_TEST_ID = "layout-builder-section";
export const LAYOUT_PREVIEW_SECTION_TEST_ID = "layout-preview-section";
export const LAYOUT_BUILDER_EDIT_CELLS_TEST_ID = "layout-builder-edit-cells";

/** Suffixes appended to `${LAYOUT_BUILDER_SECTION_TEST_ID}-${index}` in SectionBuilder. */
export const LAYOUT_BUILDER_SECTION_COLLAPSE_TEST_ID_SUFFIX = "collapse";
export const LAYOUT_BUILDER_SECTION_BODY_TEST_ID_SUFFIX = "body";

/** Accessible labels for SectionBuilder chrome (icon-only controls). */
export const ARIA_EXPAND_SECTION = "Expand section";
export const ARIA_COLLAPSE_SECTION = "Collapse section";
export const ARIA_MOVE_SECTION_UP = "Move section up";
export const ARIA_MOVE_SECTION_DOWN = "Move section down";
export const ARIA_REMOVE_SECTION = "Remove section";
export const ARIA_BINDING_ROW_ACTIONS = "Row actions";
export const ARIA_EDIT_CELLS = "Edit cells";
export const ARIA_DONE_EDITING_CELLS = "Done editing cells";
export const ARIA_MOVE_ROW_UP = "Move row up";
export const ARIA_MOVE_ROW_DOWN = "Move row down";
export const ARIA_REMOVE_ROW = "Remove row";

/** Sections tab: single Add section dropdown (type names only; help accordion explains each type). */
export const ADD_SECTION_LABEL = "Add section";
export const ADD_SECTION_TEST_ID = "add-section";
export const ADD_SECTION_MENU_TEST_ID = "add-section-menu";
